import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

import { useAuth } from "../../context/AuthContext";
import {
  getRoleAssignmentsLabel,
  getRoleFinanceAccessLabel,
  getRolePropertyAccessLabel,
  sortRolesForBehaviourSummary,
} from "../../utils/roleAccess";

export default function RolesReferenceTable({
  roles = [],
  title = "Roles",
  sx,
}) {
  const { permissions, roleCapabilities } = useAuth();
  const sortedRoles = sortRolesForBehaviourSummary(roles);

  return (
    <Paper sx={{ p: 2, borderRadius: 2, ...sx }} elevation={1}>
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        {title}
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 600 }}>Role</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Description</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>All properties/units</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Finance module</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Assignments</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedRoles.length === 0 ? (
              <TableRow>
                <TableCell colSpan={5} align="center" sx={{ py: 3 }}>
                  <Typography color="text.secondary">No roles found.</Typography>
                </TableCell>
              </TableRow>
            ) : (
              sortedRoles.map((role) => (
                <TableRow key={role.id} hover>
                  <TableCell>
                    <Typography fontWeight={500}>
                      {role.display_name || role.name}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {role.description || "—"}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {getRolePropertyAccessLabel(role.name, permissions, roleCapabilities)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {getRoleFinanceAccessLabel(role.name, roleCapabilities)}
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="body2" color="text.secondary">
                      {getRoleAssignmentsLabel(role.name)}
                    </Typography>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
